'use client';

import { ReactNode } from 'react';
import { Flex, Checkbox, Field } from '@chakra-ui/react';

type CheckBoxAppProps = {
  children: ReactNode;
  value: boolean;
  error?: string;
  onChange: (data: boolean) => void;
  width: string;
};

const FormCheckBox = ({
  children,
  value,
  error,
  onChange,
  width,
}: CheckBoxAppProps) => {
  return (
    <Field.Root
      pos="relative"
      w={width}
      invalid={!!error}
      display="flex"
      justifyContent="center"
    >
      <Checkbox.Root
        variant="subtle"
        color={{ base: '#0A1B2B', _dark: 'gray.100' }}
        colorPalette="cyan"
        invalid={!!error}
        checked={value}
        onCheckedChange={({ checked }) =>
          typeof checked === 'boolean' && onChange(checked)
        }
      >
        <Checkbox.HiddenInput />
        <Checkbox.Control />
        <Checkbox.Label>{children}</Checkbox.Label>
      </Checkbox.Root>
      {error && (
        <Flex align="center" ml="1">
          <Field.ErrorIcon w="3.5" h="3.5" mr="1" />
          <Field.ErrorText>{error}</Field.ErrorText>
        </Flex>
      )}
    </Field.Root>
  );
};

export default FormCheckBox;
